import { render, staticRenderFns } from "./CopyText.vue?vue&type=template&id=8de537ca&scoped=true"
import script from "./CopyText.vue?vue&type=script&lang=js"
export * from "./CopyText.vue?vue&type=script&lang=js"
import style0 from "./CopyText.vue?vue&type=style&index=0&id=8de537ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de537ca",
  null
  
)

export default component.exports